import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },

  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  companyDetailSubHead: {
    marginBottom: theme.spacing(2),
  },
  updateRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
    gap: '24px',
    flexWrap: 'wrap',
  },
  closeIconButton: {
    padding: theme.spacing(0),
    margin: theme.spacing(-2.5, 0, -3, 0.187),
  },
  recipientsRowsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  addButtonContainer: {
    margin: theme.spacing(3, 0, 0, 0),
    textAlign: 'left',
  },
}))
